module.exports = __webpack_public_path__ + "4525c62c25768acb943c5ee66ad39b30.svg";